import React, { useContext, useEffect } from "react";
import { format } from "date-fns";
import "./styles.css";

import {
  Behance,
  Dribbble,
  Github,
  Instagram,
  Linkedin,
  Location,
  Mail,
  Phone,
  Pinterest,
  Skype,
  Twitter,
  Website,
  Whatsapp,
} from "../../Icons/Icons";
import { ResumeContext } from "../../../contexts/resumeContext";
import { iconMap } from "../../../utils/constants";

function Magic({ info }) {
  const { setColorOptions, activeColor, setActiveColor, resumeHeadings, setImgSupported } =
    useContext(ResumeContext);

  useEffect(() => {
    setColorOptions(["#1F2B1D", "#0A0D2B", "#A66073", "#2B1506"]);
    setActiveColor("#1F2B1D");
    setImgSupported(true)
  }, []);

  const {
    personalDetails,
    educationDetails,
    professionalDetails,
    skills,
    social,
    misc,
  } = info;

  const education = Object.values(educationDetails || {});
  const work = Object.values(professionalDetails || {});
  const userSkills = Object.values(skills || {});
  const socialLinks = Object.values(social || {});
  const { courses, hobbies, languages, references, internships, activities, projects } =
    misc || {};
  return (
    <div className="magic">
      <div className="magic__header" style={{ background: activeColor }}>
        {personalDetails?.userImage && <img src={personalDetails?.userImage} />}
        <div>
          <h1 className="magic__title">
            {personalDetails?.firstName?.trim()}{" "}
            {personalDetails?.lastName?.trim()}
          </h1>
          <p className="magic__jobTitle">{personalDetails?.jobTitle}</p>
          {personalDetails?.summary && <p
            className="magic__header__text"
            dangerouslySetInnerHTML={{ __html: personalDetails?.summary }}
          />}
          <ul className={"magic__contactList"}>
            {personalDetails?.phone && (
              <li>
                <a href={`tel:${personalDetails?.phone?.trim()}`}>
                  <Phone />
                  {personalDetails?.phone?.trim()}
                </a>
              </li>
            )}
            {(personalDetails?.address?.trim() ||
              personalDetails?.postalCode?.trim()) && (
              <li>
                <Location />
                {personalDetails?.address?.trim()} 
                {personalDetails?.postalCode?.trim() && " - "}
                {personalDetails?.postalCode?.trim()}
              </li>
            )}
            {personalDetails?.email && (
              <li>
                <a href={`mailto:${personalDetails?.email?.trim()}`}>
                  <Mail /> {personalDetails?.email?.trim()}
                </a>
              </li>
            )}
            {socialLinks.map((link, ix) =>
              link.link !== "" ? (
                <li>
                  <a href={link.link} target="_blank">
                    {iconMap[link.label?.toLowerCase()] || <>{link.label}: </>}{" "}
                    {link.link}
                  </a>
                </li>
              ) : null
            )}
          </ul>
        </div>
      </div>
      <div className="magic__body">
        <div className="magic__row">
          <div className="magic__col">
            {!!userSkills?.length && <div className="magic__section">
              <h3
                className="magic__body__heading"
                style={{ borderColor: `${activeColor}88`, color: activeColor }}
              >
                {resumeHeadings?.SK}
              </h3>
              <ul>
                {userSkills.map((skill, ix) => (
                  <li key={skill + ix}>{skill}</li>
                ))}
              </ul>
            </div>}
            {!!education?.length && <div className="magic__section">
              <h3
                className="magic__body__heading"
                style={{ borderColor: `${activeColor}88`, color: activeColor }}
              >
                {resumeHeadings?.AD}
              </h3>
              {education?.map((ed, ix) => (
                <div className={"magic__subsection"} key={`ed_${ix}`}>
                  <p
                    className={"magic__section__heading"}
                    style={{ marginBottom: 0 }}
                  >
                    {ed.degree}
                  </p>
                  <p className={"magic__subsection_text"}>{ed.institute}</p>
                  <p className="magic__subsection_text">
                    {ed.startDate && (
                      <>{format(new Date(ed.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {ed.endDate && (
                      <>- {format(new Date(ed.endDate), "MMM yyyy")}</>
                    )}
                    {ed.location && <> | {ed.location}</>}
                  </p>
                  <div
                    className={"magic__subsection_text"}
                    dangerouslySetInnerHTML={{ __html: ed.description }}
                  />
                </div>
              ))}
            </div>}
            {!!projects?.length && <div className="magic__section">
              <h3
                className="magic__body__heading"
                style={{ borderColor: `${activeColor}88`, color: activeColor }}
              >
                {resumeHeadings?.PRO}
              </h3>
              {projects?.map((pro, ix) => (
                <div className={"magic__subsection"} key={`pro_${ix}`}>
                  <p
                    className={"magic__section__heading"}
                    style={{ marginBottom: 0 }}
                  >
                    {pro.title}
                  </p>
                  <p className={"magic__subsection_text"}>{pro.company}</p>
                  <p className="magic__subsection_text">
                    {pro.startDate && (
                      <>{format(new Date(pro.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {pro.endDate && (
                      <>- {format(new Date(pro.endDate), "MMM yyyy")}</>
                    )}
                  </p>
                  <div
                    className={"magic__subsection_text"}
                    dangerouslySetInnerHTML={{ __html: pro.description }}
                  />
                </div>
              ))}
            </div>}
            {!!hobbies?.length && (
              <div className="magic__section">
                <h3
                  className="magic__body__heading"
                  style={{
                    borderColor: `${activeColor}88`,
                    color: activeColor,
                  }}
                >
                  {resumeHeadings?.HOB}
                </h3>
                <div className={"magic__subsection"}>
                  <p className={"magic__subsection_text"}>{hobbies}</p>
                </div>
              </div>
            )}
            {!!languages?.length && (
              <div className="magic__section">
                <h3
                  className="magic__body__heading"
                  style={{
                    borderColor: `${activeColor}88`,
                    color: activeColor,
                  }}
                >
                  {resumeHeadings?.LAN}
                </h3>
                <div className={"magic__subsection"}>
                  <p className={"magic__subsection_text"}>{languages}</p>
                </div>
              </div>
            )}
          </div>
          <div className="magic__col">
            {!!work?.length && <div className="magic__section">
              <h3
                className="magic__body__heading"
                style={{ borderColor: `${activeColor}88`, color: activeColor }}
              >
                {resumeHeadings?.WE}
              </h3>
              {work.map((exp, ix) => (
                <div className={"magic__subsection"} key={`exp_${ix}`}>
                  <p
                    className={"magic__section__heading"}
                    style={{ marginBottom: 0 }}
                  >
                    {exp.jobTitle}
                    <span style={{ float: "right", fontWeight: 400 }}>
                      {exp.startDate && (
                        <>{format(new Date(exp.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {exp.endDate && (
                         <>- {exp.endDate === "Present" ? "Present" : format(new Date(exp.endDate), "MMM yyyy")}</>
                      )}
                    </span>
                  </p>
                  <p className={"magic__subsection_text"}>
                    {exp.company}
                    <span style={{ float: "right" }}>{exp.location}</span>
                  </p>
                  <div
                    className={"magic__subsection_text"}
                    dangerouslySetInnerHTML={{ __html: exp.description }}
                  />
                </div>
              ))}
            </div>}
            {!!internships?.length && (
              <div className="magic__section">
                <h3
                  className="magic__body__heading"
                  style={{
                    borderColor: `${activeColor}88`,
                    color: activeColor,
                  }}
                >
                  {resumeHeadings?.INT}
                </h3>
                {internships.map((intern, ix) => (
                  <div className={"magic__subsection"} key={`intern_${ix}`}>
                    <p
                      className="magic__section__heading"
                      style={{ marginBottom: 0 }}
                    >
                      {intern.jobTitle}
                      <span style={{ float: "right", fontWeight: 400 }}>
                        {intern.startDate && (
                          <>{format(new Date(intern.startDate), "MMM yyyy")}</>
                        )}{" "}
                        {intern.endDate && (
                          <>- {format(new Date(intern.endDate), "MMM yyyy")}</>
                        )}
                      </span>
                    </p>
                    <p className={"magic__subsection_text"}>
                      {intern.company}
                      <span style={{ float: "right" }}>{intern.location}</span>
                    </p>
                    <div
                      className={"magic__subsection_text"}
                      dangerouslySetInnerHTML={{ __html: intern.description }}
                    />
                  </div>
                ))}
              </div>
            )}
            {!!courses?.length && (
              <div className={"magic__section"}>
                <h3
                  className={"magic__body__heading"}
                  style={{ color: activeColor }}
                >
                  {resumeHeadings?.CR}
                </h3>
                {courses?.map((course, ix) => (
                  <div className={"magic__subsection"} key={`course_${ix}`}>
                    <p
                      className={"magic__section__heading"}
                      style={{ marginBottom: 0 }}
                    >
                      {course.name}
                    </p>
                    <p className={"magic__subsection_text"}>
                      {course.institution}{" "}
                      <span style={{ float: "right" }}>
                        {course.startDate && (
                          <>{format(new Date(course.startDate), "MMM yyyy")}</>
                        )}{" "}
                        {course.endDate && (
                          <>- {format(new Date(course.endDate), "MMM yyyy")}</>
                        )}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            )}
            {!!activities?.length && (
              <div className="magic__section">
                <h3
                  className="magic__body__heading"
                  style={{
                    borderColor: `${activeColor}88`,
                    color: activeColor,
                  }}
                >
                  {resumeHeadings?.ACT}
                </h3>
                {activities.map((activity, ix) => (
                  <div className={"magic__subsection"} key={`activity_${ix}`}>
                    <p
                      className={"magic__section__heading"}
                      style={{ marginBottom: 0 }}
                    >
                      {activity.title}
                    </p>
                    <p className={"magic__subsection_text"}>
                      {activity.institution}
                      <span style={{ float: "right" }}>
                        {activity.startDate && (
                          <>
                            {format(new Date(activity.startDate), "MMM yyyy")}
                          </>
                        )}{" "}
                        {activity.endDate && (
                          <>
                            - {format(new Date(activity.endDate), "MMM yyyy")}
                          </>
                        )}
                      </span>
                    </p>
                    <div
                      className={"magic__subsection_text"}
                      dangerouslySetInnerHTML={{ __html: activity.description }}
                    />
                  </div>
                ))}
              </div>
            )}
            {!!references?.length && (
              <div className={"magic__section"}>
                <h3
                  className={"magic__body__heading"}
                  style={{ color: activeColor }}
                >
                  {resumeHeadings?.REF}
                </h3>
                {references?.map((ref, ix) => (
                  <div className="magic__subsection" key={`ref_${ix}`}>
                    <p
                      className="magic__section__heading"
                      style={{ marginBottom: 0 }}
                    >
                      {ref.name}{" "}
                      {ref.institution && <>from {ref.institution}</>}
                    </p>
                    <p className="magic__subsection_text">
                      {ref.email}{" "}
                      {ref.phone && <> &nbsp; | &nbsp; {ref.phone}</>}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Magic;
